import { File } from "../proto/Global_pb";
import { memorize } from "./utils";

export const base64Prefix = memorize((string: string): string => {
  const mimeTypesMap: any = {
    "/": "image/jpeg",
    i: "image/png",
    R: "image/gif",
    U: "image/webp",
    J: "application/pdf",
  };
  return `data:${mimeTypesMap[string.charAt(0)]};base64,${string}`;
});

export const formatBytes = memorize((bytes: number, decimals: number = 2): string => {
  if (bytes === 0 || isNaN(bytes)) return "0 Bytes";
  const kb = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const i = Math.floor(Math.log(bytes) / Math.log(kb));
  return `${parseFloat((bytes / Math.pow(kb, i)).toFixed(dm))} ${["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][i]}`;
});

export const downloadURL = (url: string, fileName: File.AsObject["name"]): void => {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  a.remove();
  // window.URL.revokeObjectURL(url);
};

export const isImageType = (name: string) => Boolean(name.startsWith("image"));
